import React from 'react'
import { Platform, StyleSheet, View } from 'react-native'
import Animated, {
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated'
import { Gesture, GestureDetector } from 'react-native-gesture-handler'
import cn from '@ui/utils/cn'

import ModalBackdrop from './ModalBackdrop'
import { ModalContentProps } from './types'

export default function ModalContent({
  children,
  onPress,
  animation,
  contentClassName,
  extraGestures = [],
  backdropContent,
  intensity = 100,
  enabled,
}: ModalContentProps) {
  // const blurStyle = useAnimatedStyle(() => {
  //   return {
  //     opacity: interpolate(animation.value, [0, 100], [0, 1]),
  //   }
  // })

  const contentStyle = useAnimatedStyle(() => {
    return {
      opacity: interpolate(animation.value, [0, 75], [0, 1]),
    }
  }, [])

  const interaction = Gesture.Race(
    Gesture.Tap()
      .runOnJS(true)
      .onEnd(() => onPress?.()),
    ...extraGestures
  )

  return (
    <ModalBackdrop
      intensity={intensity}
      animation={animation}
      enabled={enabled}
    >
      <GestureDetector gesture={interaction}>
        <View
          style={[
            StyleSheet.absoluteFill,
            {
              pointerEvents: enabled ? 'auto' : 'none',
            },
          ]}
        />
      </GestureDetector>
      <Animated.View
        style={[
          contentStyle,
          {
            pointerEvents: Platform.select({
              default: 'box-none',
              web: 'none',
            }),
          },
        ]}
        className={cn('absolute h-full w-full', contentClassName)}
      >
        {backdropContent}
        {children}
      </Animated.View>
    </ModalBackdrop>
  )
}
